module.exports = __webpack_public_path__ + "static/media/rs.fd7f2205.svg";